import React, { useEffect, useState } from "react";
import { useNotification } from "./Notification";
import { getTokens, messaging } from "../configs/firebase";
import { onMessage } from "firebase/messaging";
import { useStorage } from "../hooks/useLocalStorage";
import { useLocation, useNavigate } from "react-router-dom";
import { postData } from "../api/api";

export default function NotificationApi({ children }) {
  const [isTokenFound, setTokenFound] = useState(false);
  const { notificationApi } = useNotification();
  const [use, setUse] = useStorage("use", null);
  const [token, setToken, loadingToken] = useStorage("tokenNoti", "");
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname;
  useEffect(() => {
    if (use.id) {
      postData("/device-tokens", { deviceToken: token })
        .then((e) => {
          
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [token, use]);

  useEffect(() => {
    loadingToken();
  }, [currentPath]);
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js") // Đảm bảo đường dẫn đúng
        .then(function (registration) {
          console.log(
            "Service Worker registered with scope:",
            registration.scope
          );
        })
        .catch(function (error) {
          console.error("Service Worker registration failed:", error);
        });
    }

    // Lấy token của client
    getTokens(setTokenFound);
    // onMessage(messaging, (payload) => {
    //   console.log("Message received: ", payload);
    //   // Handle the foreground message here

    //   notificationApi(
    //     "info",
    //     payload.notification.title,
    //     payload.notification.body
    //   );
    // });
    return () => {};
  }, []);

  return <>{children}</>;
}
